import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { LiberacaoDesconto } from '../../models/liberacao-descontos/liberacao-desconto';

@Injectable({
  providedIn: 'root'
})

export class LiberacaoDescontoService {
  private baseUrl: string;
  private headers = new HttpHeaders();
  
  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public add(liberacao_desconto: LiberacaoDesconto): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "liberacao_desconto": liberacao_desconto
    };

    return this.http.post<boolean>(this.baseUrl + "api/LiberacaoDesconto/Add", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getByGuidClienteNapis(): Observable<LiberacaoDesconto> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<LiberacaoDesconto>(this.baseUrl + "api/LiberacaoDesconto/GetByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public update(liberacao_desconto: LiberacaoDesconto): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "liberacao_desconto": liberacao_desconto
    };

    return this.http.post<boolean>(this.baseUrl + "api/LiberacaoDesconto/Update", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }
}
